import React, { useEffect, useState } from "react";
import { Table, Space, Button, Row, Col, Input, Tag, Select, notification, Tooltip, Pagination } from "antd";
import { SearchOutlined, SendOutlined, EyeOutlined, } from "@ant-design/icons";
import { invoiceService } from "../../../services";
import { Link } from "react-router-dom";
import { useDebounce } from "../../../hooks/useDebounce";
import { changeDocumentTitle } from "../../../utils/title";

function Invoice() {

  const [loading, setLoading] = useState(false);
  const [mailLoading, setMailLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [search, setSearch] = useState(null)
  const debouncedSearch = useDebounce(search, 500);

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "SAV",
      dataIndex: 'SAV',
      key: "SAV",
      render: (text, record, index) =>
        ((pagination.current - 1) * pagination.pageSize + index + 1).toString().padStart(5, "0"),
    },
    {
      title: "Invoice No.",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",

      render: (name) => <span style={{ textTransform: "capitalize" }}>{name}</span>
    },
    {
      title: "Chasis No.",
      dataIndex: "vehicles",
      key: "ChasisNumber",
      render: (vehicles) => vehicles?.[0]?.chasis_no || "N/A",
    },
    {
      title: "Container No.",
      dataIndex: "container_number",
      key: "ContainerNumber",
      render: (container_number) => container_number || "N/A",
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "Discount",
      render: (discount) => discount || "N/A",
    },
    {
      title: "Payment Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <Tag
          type="primary"
          size="small"
          style={{
            backgroundColor: record.is_partial === 1 ? "orange" : record.is_partial === 2 ? "#06D652" : "#E4D766",
            color: record.is_partial === 1 ? "white" : record.is_partial === 2 ? "white" : "black"
          }}
        >
          {record.is_partial === 1 ? "Partial" : record.is_partial === 2 ? "Paid" : "Unpaid"}
        </Tag>
      ),
    },
    {
      title: "Invoice Status",
      dataIndex: "status",
      key: "InvoiceStatus",
      render: (status) => (
        <Tag
          type="primary"
          size="small"
          style={{
            backgroundColor: status === 1 ? "#06D652" : status === 0 ? "#B83D3D" : "transparent",
            borderColor: status === 1 ? "#06D652" : status === 0 ? "#B83D3D" : "transparent",
            color: status === 1 ? "white" : status === 0 ? "white" : "transparent"
          }}
        >
          {status === 1 ? "Approved" : "Not Approved"}
        </Tag>
      ),
    },

    {
      title: "Actions",
      key: "Actions",
      render: (text, record, { _id }) => (
        <Space size="small">
           {/* <Tooltip title='Send'>
           {record.status === 1 &&
              <Button type="primary" loading={mailLoading} size="small" onClick={() => sendMail(record.id, record.user_id)}>
                <SendOutlined />
              </Button>} 
          </Tooltip> */}

          {((record?.vehicles?.length ?? 0) > 0 || record.user) && <Link to={`/invoice/view/${record.id}`}>
            <Tooltip title='View'>
              <EyeOutlined />
            </Tooltip>
          </Link>}
        </Space >
      ),
    },
  ];

  const sendMail = async (id, user_id) => {
    setMailLoading(true);
    const data = { invoiceId: id, userId: user_id };
    const response = await invoiceService.sendEmail(data);
    setMailLoading(false);
    if (response.success) {
      notification.success({ message: response.message, placement: "topRight" });
      initialize();
    }
  }

  const initialize = async (page = 1, pageSize = pagination.pageSize) => {
    setLoading(true);
    const { success, data } = await invoiceService.fetch(page, pageSize, debouncedSearch);
    if (success) {
      setInvoices(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
    setLoading(false);
  };

  useEffect(() => {
    changeDocumentTitle("Invoices");

    initialize(pagination.current, pagination.pageSize);
  }, [debouncedSearch]);

  return (
    <div style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "8px" }}>

      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3 mb-4">Invoices </h1>
        <Input
          placeholder="Search by Name & Container No"
          prefix={<SearchOutlined />}
          style={{
            width: "30%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <Table
        columns={columns}
        dataSource={invoices}
        loading={loading}
        style={{ paddingTop: "10px" }}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}
export default Invoice;
